<template>
  <SoDialog
    v-model="value"
    :loading="isLoading"
    width="600"
    @on-close="$emit('closeModal')"
  >
    <template v-if="!isLoading && transaction">
      <div class="d-flex align-center justify-space-between">
        <h4>{{ transaction.transactionType }}: {{ transaction.id }}</h4>
        <SoStatus :status="transaction.status" />
      </div>
      <dl class="mt-5 mb-7 dl dl--aligned">
        <dt>Description</dt>
        <dd>{{ transaction.description ?? "-" }}</dd>
        <dt>Reference</dt>
        <dd>{{ transaction.reference ?? "-" }}</dd>
        <dt>Accepted</dt>
        <dd>{{ formatDate(transaction.acceptedDttm) }}</dd>
        <dt>Created</dt>
        <dd>{{ formatDate(transaction.createdDttm) }}</dd>
        <dt>Created by</dt>
        <dd>{{ accountCreditDetails.data?.createdUser || "-" }}</dd>
      </dl>
    </template>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { formatDate } from "@/helpers/dateHelper"
  import SoDialog from "@/components/SoDialog.vue"
  import SoStatus from "@/components/SoStatus.vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { TransactionService } from "@/services/TransactionService"

  export default defineComponent({
    components: {
      SoDialog,
      SoStatus,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
      transactionId: {
        type: Number,
        default: null,
      },
      accountCreditId: {
        type: String,
        default: null,
      },
    },
    emits: ["update:modelValue", "closeModal"],
    data() {
      return {
        transactions: useCurrentAccountStore().transactions,
        formatDate,
        accountCreditDetails: TransactionService.getAccountCreditDetails(
          this.accountCreditId,
        ),
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
      transaction() {
        return this.transactions.data.find(
          (transaction) => transaction.id === this.transactionId,
        )
      },
      isLoading() {
        return (
          this.transactions.isFetching || this.accountCreditDetails.isFetching
        )
      },
    },
  })
</script>
